import React from 'react';
import Api from '../components/Api';
import { useState, useRef, useCallback,useEffect } from "react";
import swal from 'sweetalert';
import { gsap } from 'gsap'

function MiniGame() {

    useEffect(() => {
        swal("To play, select the name of the characters");
    }, []);

    var game = [];

    const [search, setSearch] = useState('');

    const searchInput = useRef(null);

    const handleSearch = useCallback(() => {
        setSearch(searchInput.current.value);
    }, [])

    const characters = Api();


    const winner = () => {
        let ramdonWin = Math.floor(Math.random() * (2 - 1 + 1) + 1);
        if (ramdonWin === 1) {

            swal("Player 1 Win");

            resetGame();


        } else {
            swal("Player 2 Win");

            resetGame();

        }
        game = [];
    }

    const resetGame = () => {
        document.getElementById("p-1").src = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9c64cfe3-bb3b-4ae8-b5a6-d2f39d21ff87/d3jme6i-8c702ad4-4b7a-4763-9901-99f8b4f038b0.png/v1/fill/w_600,h_400,strp/fondo_transparente_png_by_imsnowbieber_d3jme6i-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDAwIiwicGF0aCI6IlwvZlwvOWM2NGNmZTMtYmIzYi00YWU4LWI1YTYtZDJmMzlkMjFmZjg3XC9kM2ptZTZpLThjNzAyYWQ0LTRiN2EtNDc2My05OTAxLTk5ZjhiNGYwMzhiMC5wbmciLCJ3aWR0aCI6Ijw9NjAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Ymv-MHRcmXXpzmL3f0xZ0mCcyU85lCLnk0jbOnCO8Zg';
        document.getElementById("p-2").src = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9c64cfe3-bb3b-4ae8-b5a6-d2f39d21ff87/d3jme6i-8c702ad4-4b7a-4763-9901-99f8b4f038b0.png/v1/fill/w_600,h_400,strp/fondo_transparente_png_by_imsnowbieber_d3jme6i-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDAwIiwicGF0aCI6IlwvZlwvOWM2NGNmZTMtYmIzYi00YWU4LWI1YTYtZDJmMzlkMjFmZjg3XC9kM2ptZTZpLThjNzAyYWQ0LTRiN2EtNDc2My05OTAxLTk5ZjhiNGYwMzhiMC5wbmciLCJ3aWR0aCI6Ijw9NjAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Ymv-MHRcmXXpzmL3f0xZ0mCcyU85lCLnk0jbOnCO8Zg';
    }

    const playVersus = () => {


        if (game.length === 2) {
            let animacionPlayer = gsap.timeline({ repeat: 0, onComplete: winner });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 10, y: 10 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: -10, y: -10 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 20, y: 20 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 10, y: 10 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: -10, y: -10 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 20, y: 20 });
            animacionPlayer.to('.player-uno', { duration: 0.2, x: 0, y: 0 });

            let animacionPlayerDos = gsap.timeline({ repeat: 0, onComplete: winner });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: -10, y: 10 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 10, y: -10 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: -20, y: 20 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: -10, y: 10 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 10, y: -10 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: -20, y: 20 });
            animacionPlayerDos.to('.player-dos', { duration: 0.2, x: 0, y: 0 });

        } else {
            swal("Select two characters to fight", "", "error");

        }


    }



    const selectPlayer = (select) => {
        if (game.length < 2) {
            game.push(select.image);

            if (game.length === 1) {

                document.getElementById("p-1").src = game[0];
            } else {

                document.getElementById("p-2").src = game[1];

            }

        } else {

            swal("You already have two characters selected", "they are ready to fight!", "error");
        }


    }

    const filteredUsers =
        characters.filter((user) => {
            return user.name.toLowerCase().includes(search.toLowerCase())
        })

    return (
        <React.Fragment>
            <section>


                <div className='versus'>
                    <div className='players'>
                        <div className='player-uno'><img id='p-1' src='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9c64cfe3-bb3b-4ae8-b5a6-d2f39d21ff87/d3jme6i-8c702ad4-4b7a-4763-9901-99f8b4f038b0.png/v1/fill/w_600,h_400,strp/fondo_transparente_png_by_imsnowbieber_d3jme6i-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDAwIiwicGF0aCI6IlwvZlwvOWM2NGNmZTMtYmIzYi00YWU4LWI1YTYtZDJmMzlkMjFmZjg3XC9kM2ptZTZpLThjNzAyYWQ0LTRiN2EtNDc2My05OTAxLTk5ZjhiNGYwMzhiMC5wbmciLCJ3aWR0aCI6Ijw9NjAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Ymv-MHRcmXXpzmL3f0xZ0mCcyU85lCLnk0jbOnCO8Zg' alt='player-uno'></img></div>
                        <div className='versus-logo'><p>VS</p></div>
                        <div className='player-dos'><img id='p-2' src='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/9c64cfe3-bb3b-4ae8-b5a6-d2f39d21ff87/d3jme6i-8c702ad4-4b7a-4763-9901-99f8b4f038b0.png/v1/fill/w_600,h_400,strp/fondo_transparente_png_by_imsnowbieber_d3jme6i-fullview.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NDAwIiwicGF0aCI6IlwvZlwvOWM2NGNmZTMtYmIzYi00YWU4LWI1YTYtZDJmMzlkMjFmZjg3XC9kM2ptZTZpLThjNzAyYWQ0LTRiN2EtNDc2My05OTAxLTk5ZjhiNGYwMzhiMC5wbmciLCJ3aWR0aCI6Ijw9NjAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.Ymv-MHRcmXXpzmL3f0xZ0mCcyU85lCLnk0jbOnCO8Zg' alt='player-uno'></img></div>
                    </div>

                    <button id='play-game' onClick={playVersus}>Play</button>
                </div>


                <div className='search'>
                    <p>Character finder</p>
                    <input type="text" value={search} ref={searchInput} onChange={handleSearch}></input>
                </div>


                <div className='list'>
                    {
                        filteredUsers.map(character => (

                            <div className='item' key={character.id}>
                                <div className='image'> <img src={character.image} alt='RyM'></img></div>
                                <h2 className='name' onClick={() => selectPlayer(character)}>{character.name}</h2>
                            </div>

                        ))
                    }
                </div>

            </section>
        </React.Fragment>
    );


}
export default MiniGame;